import pluralize from 'pluralize'
import type {ConvertToRulesetPreview} from '../types'

export type PreviewsCountSummaryProps = {
  previews: ConvertToRulesetPreview[]
}

export function PreviewsCountSummary({previews}: PreviewsCountSummaryProps) {
  const branchProtectionCount = previews?.length ?? 0
  const rulesetCount = previews?.reduce((acc, {rulesets}) => acc + rulesets.length, 0) ?? 0

  return (
    <span>
      {rulesetCount} {pluralize('ruleset', rulesetCount)}{' '}
      <span>
        will be created from {branchProtectionCount} branch protection {pluralize('rule', branchProtectionCount)}.
      </span>
    </span>
  )
}
